/**
 * Purpose: Shared loading indicator used across pages, grids, and modals.
 * Why: Keeps spinner size, layout, and messaging consistent without each
 * feature redefining its own spinner markup and CSS.
 */
import { Component, Input } from '@angular/core';

type LoadingIndicatorSize = 'sm' | 'md' | 'lg';

@Component({
    selector: 'cwr-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrls: ['./loading-indicator.component.scss'],
})
export class LoadingIndicatorComponent {
    @Input() message = 'Loading...';
    @Input() size: LoadingIndicatorSize = 'md';
    @Input() showMessage = true;
    @Input() centered = false;

    get hostClasses(): string[] {
        return [
            'loading-indicator',
            `loading-indicator--${this.size}`,
            this.centered ? 'loading-indicator--centered' : '',
        ].filter(Boolean);
    }
}
